module.exports = __webpack_public_path__ + "img/eight6Red.7bc3eaf7.jpg";